export const INLINE_LIST_BEHAVIOUR = 'inline';
export const PINNED_LIST_BEHAVIOUR = 'pinned';
export const DEFAULT_LIST_BEHAVIOUR = 'overlay';
export const MULTI_VARIANT = 'multi';
export const SINGLE_VARIANT = 'single';
